import { render, staticRenderFns } from "./MainDashboard.vue?vue&type=template&id=59e4942d&scoped=true&"
import script from "./MainDashboard.vue?vue&type=script&lang=js&"
export * from "./MainDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e4942d",
  null
  
)

export default component.exports